// extracted by mini-css-extract-plugin
module.exports = {"imageUploadContainer":"Branding_imageUploadContainer__qXOOK"};